"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _alloyReactModal = require("@adsk/alloy-react-modal");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _CenteredSpinner = require("./CenteredSpinner");
var _templateObject, _templateObject2;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
const Page = _styledComponents.default.iframe(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: 0;\n  visibility: ", ";\n"])), props => props.$hide ? "hidden" : "visible");
const ModalBodyProps = {
  style: (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 0;\n  "])))
};
const usePostMessage = (src, onMessage, options) => {
  const origin = (0, _react.useMemo)(() => src ? new URL(src).origin : "", [src]);
  const messageCallback = (0, _react.useCallback)(e => {
    var _e$ports;
    if (options !== null && options !== void 0 && options.useChannelMessaging && (_e$ports = e.ports) !== null && _e$ports !== void 0 && _e$ports.length && e.data === "init") {
      var _options$onChannelIni;
      const port2 = e.ports[0];
      if (onMessage) {
        port2.onmessage = onMessage;
      }
      options === null || options === void 0 || (_options$onChannelIni = options.onChannelInit) === null || _options$onChannelIni === void 0 || _options$onChannelIni.call(options, e, port2);
    } else if (e.origin === origin) {
      onMessage === null || onMessage === void 0 || onMessage(e);
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [origin, onMessage]);
  (0, _react.useEffect)(() => {
    if (onMessage) {
      window.addEventListener("message", messageCallback);
    }
    return () => {
      if (onMessage) {
        window.removeEventListener("message", messageCallback);
      }
    };
  }, [messageCallback, onMessage]);
};
const useIframeEventHandling = (onLoad, onError) => {
  const iframeRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    const currIframeElm = iframeRef.current;
    if (onLoad) {
      currIframeElm === null || currIframeElm === void 0 || currIframeElm.addEventListener("load", onLoad);
    }
    if (onError) {
      currIframeElm === null || currIframeElm === void 0 || currIframeElm.addEventListener("error", onError);
    }
    return () => {
      if (onLoad) {
        currIframeElm === null || currIframeElm === void 0 || currIframeElm.removeEventListener("load", onLoad);
      }
      if (onError) {
        currIframeElm === null || currIframeElm === void 0 || currIframeElm.removeEventListener("error", onError);
      }
    };
  }, [onLoad, onError]);
  return iframeRef;
};
const PagePopover = _ref => {
  let {
    src,
    className = "page-popover",
    width = "100%",
    height = "100%",
    open = true,
    show = true,
    useChannelMessaging = false,
    hashUrl,
    onChannelInit,
    onMessage,
    onLoad,
    onError,
    onPopState
  } = _ref;
  const iframeRef = useIframeEventHandling(onLoad, onError);
  usePostMessage(src, onMessage, {
    useChannelMessaging,
    onChannelInit
  });
  (0, _react.useEffect)(() => {
    if (open && hashUrl) {
      window.history.pushState({}, "", "".concat(window.location.search, "#").concat(hashUrl));
    }
  }, [open, hashUrl]);
  (0, _react.useEffect)(() => {
    if (onPopState) {
      window.addEventListener("popstate", onPopState);
    }
    return () => {
      if (onPopState) {
        window.removeEventListener("popstate", onPopState);
      }
    };
  }, [onPopState]);
  const modalProps = (0, _react.useMemo)(() => ({
    width,
    height
  }), [width, height]);
  return /*#__PURE__*/_react.default.createElement(_alloyReactModal.SimpleModal, {
    style: {},
    className: className,
    show: open,
    modalProps: modalProps,
    modalBodyProps: ModalBodyProps
  }, /*#__PURE__*/_react.default.createElement(Page, {
    "data-testid": "page-popover-iframe",
    ref: iframeRef,
    src: src,
    width: width,
    height: height,
    $hide: !show
  }), !show && /*#__PURE__*/_react.default.createElement(_CenteredSpinner.AbsoluteCenteredSpinner, null));
};
var _default = exports.default = PagePopover;
//# sourceMappingURL=PagePopover.js.map